import { AutomationTestingProps } from '@/types';

import { Checkbox } from '@@/form-components/Checkbox';

interface Props extends AutomationTestingProps {
  onChange(value: boolean): void;
  value: boolean;
  label: string;
  id: string;
}

export function TableSettingsMenuCheckbox({
  onChange,
  value,
  label,
  id = 'settings-menu-checkbox',
  'data-cy': dataCy,
}: Props) {
  return (
    <Checkbox
      id={id}
      data-cy={`${dataCy}-settings-menu-checkbox`}
      label={label}
      checked={value}
      onChange={(e) => onChange(e.target.checked)}
    />
  );
}
